import { render, staticRenderFns } from "./NotSpam.vue?vue&type=template&id=d557653e&scoped=true&"
import script from "./NotSpam.vue?vue&type=script&lang=js&"
export * from "./NotSpam.vue?vue&type=script&lang=js&"
import style0 from "./NotSpam.vue?vue&type=style&index=0&id=d557653e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d557653e",
  null
  
)

component.options.__file = "NotSpam.vue"
export default component.exports